export default {
  'pay.msg.headerTitle': 'Message Management',
  'pay.msg.subtitle.prefix': 'Message notifications are retained for ',
  'pay.msg.subtitle.suffix': ' days',
  'pay.msg.subtitle.action': 'Configure',
  'pay.msg.button.create': 'New Message',
  'pay.msg.button.batchDelete': 'Batch Delete',
  'pay.msg.button.view': 'View',
  'pay.msg.button.close': 'Close',
  'pay.msg.button.cancel': 'Cancel',
  'pay.msg.button.confirm': 'Confirm',
  'pay.msg.button.delete': 'Delete',
  'pay.msg.message.saveSuccess': 'Saved successfully',
  'pay.msg.message.selectForDelete': 'Please select the messages to delete',
  'pay.msg.message.deleteSuccess': 'Deleted successfully',
  'pay.msg.message.deleteError': 'Failed to delete',
  'pay.msg.message.batchDeleteSuccess': 'Batch delete succeeded',
  'pay.msg.message.batchDeleteError': 'Batch delete failed',
  'pay.msg.message.createSuccess': 'Sent successfully',
  'pay.msg.message.updateSuccess': 'Updated successfully',
  'pay.msg.message.createError': 'Failed to send',
  'pay.msg.message.updateError': 'Failed to update',
  'pay.msg.message.selectRecipients': 'Please select recipients',
  'pay.msg.error.fetchNoticeTypes': 'Failed to load notice type dictionary',
  'pay.msg.error.fetchTotalUsers': 'Failed to load total users',
  'pay.msg.error.fetchStoreDays': 'Failed to load retention days',
  'pay.msg.error.fetchList': 'Failed to fetch message list',
  'pay.msg.error.fetchReadStatus': 'Failed to fetch read status',
  'pay.msg.noticeType.system': 'System Notice',
  'pay.msg.noticeType.activity': 'Activity Notice',
  'pay.msg.noticeType.urgent': 'Urgent Notice',
  'pay.msg.noticeType.other': 'Other',
  'pay.msg.sendType.batch': 'Batch',
  'pay.msg.sendType.personal': 'Personal',
  'pay.msg.status.draft': 'Draft',
  'pay.msg.status.sent': 'Sent',
  'pay.msg.status.scheduled': 'Scheduled',
  'pay.msg.status.cancelled': 'Cancelled',
  'pay.msg.common.unknown': 'Unknown',
  'pay.msg.table.title': 'Message Title',
  'pay.msg.table.content': 'Message Content',
  'pay.msg.table.type': 'Message Type',
  'pay.msg.table.sendType': 'Send Type',
  'pay.msg.table.receiverCount': 'Recipients',
  'pay.msg.table.status': 'Status',
  'pay.msg.table.createdTime': 'Created Time',
  'pay.msg.table.action': 'Action',
  'pay.msg.popconfirm.deleteTitle': 'Are you sure you want to delete this message?',
  'pay.msg.popconfirm.deleteDescription':
    'This action cannot be undone. Please proceed with caution.',
  'pay.msg.readStatus.modal.title': 'Message Read Status',
  'pay.msg.readStatus.description.batch':
    'Batch messages only return the count and list of users who have read the message.',
  'pay.msg.readStatus.description.personal':
    'Personal messages display all recipients and their read status.',
  'pay.msg.readStatus.column.name': 'Name',
  'pay.msg.readStatus.column.phone': 'Phone',
  'pay.msg.readStatus.column.isRead': 'Read',
  'pay.msg.readStatus.column.readTime': 'Read Time',
  'pay.msg.readStatus.value.read': 'Read',
  'pay.msg.readStatus.value.unread': 'Unread',
  'pay.msg.storeDays.modal.title': 'Set Message Retention Days',
  'pay.msg.storeDays.form.label': 'Days',
  'pay.msg.storeDays.form.placeholder': 'Enter days',
  'pay.msg.storeDays.form.required': 'Please enter the retention days',
  'pay.msg.details.modal.title': 'Message Detail',
  'pay.msg.details.section.basic': 'Basic Information',
  'pay.msg.details.section.time': 'Schedule',
  'pay.msg.details.section.system': 'System Information',
  'pay.msg.details.field.content': 'Message Content',
  'pay.msg.details.field.type': 'Message Type',
  'pay.msg.details.field.sendType': 'Send Type',
  'pay.msg.details.field.status': 'Message Status',
  'pay.msg.details.field.targets': 'Recipients',
  'pay.msg.details.field.receiverCount': 'Recipient Count',
  'pay.msg.details.field.createdTime': 'Created Time',
  'pay.msg.details.field.startTime': 'Start Time',
  'pay.msg.details.field.endTime': 'End Time',
  'pay.msg.details.field.updatedTime': 'Updated Time',
  'pay.msg.details.field.remark': 'Remark',
  'pay.msg.form.section.basic': 'Basic Information',
  'pay.msg.form.section.status': 'Status & Schedule',
  'pay.msg.form.section.remark': 'Remark',
  'pay.msg.form.title.label': 'Message Title',
  'pay.msg.form.title.placeholder': 'Enter the message title',
  'pay.msg.form.title.required': 'Please enter the message title',
  'pay.msg.form.title.max': 'Title cannot exceed 100 characters',
  'pay.msg.form.content.label': 'Message Content',
  'pay.msg.form.content.placeholder': 'Enter the message content',
  'pay.msg.form.content.required': 'Please enter the message content',
  'pay.msg.form.content.max': 'Content cannot exceed 1000 characters',
  'pay.msg.form.type.label': 'Message Type',
  'pay.msg.form.type.placeholder': 'Select message type',
  'pay.msg.form.type.required': 'Please select the message type',
  'pay.msg.form.sendType.label': 'Send Type',
  'pay.msg.form.sendType.placeholder': 'Select send type',
  'pay.msg.form.sendType.required': 'Please select the send type',
  'pay.msg.form.sendType.selectOwner': 'Select Owner',
  'pay.msg.form.sendType.personalLabel': 'Recipients',
  'pay.msg.form.sendType.personalPlaceholder':
    'Enter usernames separated by commas or click to select owners',
  'pay.msg.form.sendType.personalExtra':
    'Enter usernames separated by commas, e.g. user1,user2,user3, or click the button above to select owners',
  'pay.msg.form.sendType.personal.required': 'Please enter the recipients',
  'pay.msg.form.sendType.personal.pattern':
    'Please enter valid usernames separated by commas',
  'pay.msg.form.status.label': 'Message Status',
  'pay.msg.form.status.placeholder': 'Select message status',
  'pay.msg.form.status.required': 'Please select the message status',
  'pay.msg.form.startTime.label': 'Send Time',
  'pay.msg.form.startTime.placeholder': 'Select send time',
  'pay.msg.form.startTime.required': 'Please select the send time',
  'pay.msg.form.remark.label': 'Remark',
  'pay.msg.form.remark.placeholder': 'Enter remark (optional)',
  'pay.msg.form.remark.max': 'Remark cannot exceed 200 characters',
  'pay.msg.form.ownerModal.title': 'Select Owner',
  'pay.msg.form.ownerModal.ok': 'Confirm Selection',
  'pay.msg.form.ownerModal.cancel': 'Cancel',
  'pay.msg.form.ownerModal.selected': '{count} owners selected:',
  'pay.msg.form.ownerModal.columns.username': 'Username',
  'pay.msg.form.ownerModal.columns.name': 'Name',
  'pay.msg.form.ownerModal.columns.phone': 'Phone',
  'pay.msg.form.ownerModal.columns.email': 'Email',
  'pay.msg.form.ownerModal.columns.idCard': 'ID Number',
  'pay.msg.form.ownerModal.columns.role': 'Role',
  'pay.msg.form.ownerModal.columns.status': 'Status',
  'pay.msg.form.ownerModal.role.owner': 'Owner',
  'pay.msg.form.ownerModal.role.tenant': 'Tenant',
  'pay.msg.form.ownerModal.role.visitor': 'Visitor',
  'pay.msg.form.ownerModal.status.active': 'Active',
  'pay.msg.form.ownerModal.status.disabled': 'Disabled',
  'pay.msg.preview.modal.title': 'Message Detail',
  'pay.msg.preview.section.basic': 'Basic Information',
  'pay.msg.preview.section.time': 'Schedule',
  'pay.msg.preview.section.system': 'System Information',
  'pay.msg.preview.field.title': 'Message Title',
  'pay.msg.preview.field.content': 'Message Content',
  'pay.msg.preview.field.type': 'Message Type',
  'pay.msg.preview.field.sendType': 'Send Type',
  'pay.msg.preview.field.status': 'Message Status',
  'pay.msg.preview.field.targets': 'Recipients',
  'pay.msg.preview.field.startTime': 'Start Time',
  'pay.msg.preview.field.endTime': 'End Time',
  'pay.msg.preview.field.createdTime': 'Created Time',
  'pay.msg.preview.field.updatedTime': 'Updated Time',
  'pay.msg.preview.field.remark': 'Remark',
  'pay.msg.preview.button.close': 'Close',
  'pay.msg.drawer.title.view': 'View Message',
  'pay.msg.drawer.title.create': 'New Message',
  'pay.msg.button.createSubmit': 'Create',
  'pay.bill.headerTitle': 'Bill Payment',
  'pay.bill.subtitle.base': 'View and manage all pending bills',
  'pay.bill.subtitle.current.building': 'Current selection: {building}',
  'pay.bill.subtitle.current.buildingFloor': 'Current selection: {building} - {floor}',
  'pay.bill.subtitle.current.full': 'Current selection: {building} - {floor} - {house}',
  'pay.bill.tree.title': 'Building / Floor / House Selector',
  'pay.bill.tree.floorFallback': 'Floor {floor}',
  'pay.bill.common.unknown': 'Unknown',
  'pay.bill.error.loadRecentMonths': 'Failed to load recent six months',
  'pay.bill.error.loadTreeData': 'Failed to load building tree data',
  'pay.bill.breadcrumb.pay': 'Payment Management',
  'pay.bill.breadcrumb.bill': 'Bill Payment',
  'pay.bill.table.headerTitle': 'Pending Bill List',
  'pay.bill.table.houseInfo': 'House Info',
  'pay.bill.table.parkingInfo': 'Parking Information',
  'pay.bill.table.billName': 'Bill Name',
  'pay.bill.table.billNo': 'Bill No.',
  'pay.bill.table.feeType': 'Fee Type',
  'pay.bill.table.period': 'Billing Period',
  'pay.bill.table.ownerName': 'Owner Name',
  'pay.bill.table.ownerPhone': 'Owner Phone',
  'pay.bill.table.ownerEmail': 'Owner Email',
  'pay.bill.table.finalAmount': 'Final Amount Due',
  'pay.bill.table.remainAmount': 'Remaining Amount',
  'pay.bill.table.paymentStatus': 'Payment Status',
  'pay.bill.table.dueDate': 'Due Date',
  'pay.bill.table.action': 'Action',
  'pay.bill.status.unpaid': 'Unpaid',
  'pay.bill.status.paid': 'Paid',
  'pay.bill.status.overdue': 'Overdue',
  'pay.bill.status.partial': 'Partially Paid',
  'pay.bill.status.partial_paid': 'Partially Paid',
  'pay.bill.status.cancelled': 'Cancelled',
  'pay.bill.filter.unpaid': 'Pending',
  'pay.bill.filter.paid': 'Paid',
  'pay.bill.filter.overdue': 'Overdue',
  'pay.bill.filter.partial_paid': 'Partially Paid',
  'pay.bill.filter.cancelled': 'Cancelled',
  'pay.bill.approval.notified': 'Notified',
  'pay.bill.message.billIdMissing': 'Bill ID is missing',
  'pay.bill.message.feeTypeMissing': 'Fee type is missing',
  'pay.bill.error.loadStatusOptions': 'Failed to load payment status dictionary',
  'pay.bill.error.loadApprovalStatus': 'Failed to load approval status dictionary',
  'pay.bill.error.loadFeeTypeOptions': 'Failed to load fee type dictionary',
  'pay.bill.error.loadStatusStats': 'Failed to load bill status statistics',
  'pay.bill.error.fetchList': 'Failed to fetch pending bill list',
  'pay.bill.table.pagination.total': 'Items {start}-{end} of {total}',
  'pay.bill.button.pay': 'Pay',
  'pay.bill.button.view': 'View',
  'pay.bill.payment.method.cash': 'Cash',
  'pay.bill.payment.method.wechat': 'WeChat',
  'pay.bill.payment.method.alipay': 'Alipay',
  'pay.bill.payment.method.bank': 'Bank Transfer',
  'pay.bill.payment.error.loadPaymentMethods': 'Failed to load payment methods',
  'pay.bill.payment.error.unknownFeeType': 'Unknown fee type',
  'pay.bill.payment.error.fetchDetail': 'Failed to fetch bill detail',
  'pay.bill.payment.error.incomplete': 'Bill information is incomplete',
  'pay.bill.payment.message.success': 'Payment processed successfully',
  'pay.bill.payment.message.failure': 'Payment processing failed',
  'pay.bill.payment.drawerTitle': '{type} Payment',
  'pay.bill.payment.section.paymentInfo': 'Payment Information',
  'pay.bill.payment.form.statusLabel': 'Payment Status',
  'pay.bill.payment.form.statusPlaceholder': 'Select payment status',
  'pay.bill.payment.form.statusRequired': 'Please select the payment status',
  'pay.bill.payment.form.methodLabel': 'Payment Method',
  'pay.bill.payment.form.methodPlaceholder': 'Select payment method',
  'pay.bill.payment.form.referenceLabel': 'Payment Reference',
  'pay.bill.payment.form.referencePlaceholder': 'Enter payment reference (optional)',
  'pay.bill.payment.form.remarkLabel': 'Remark',
  'pay.bill.payment.form.remarkPlaceholder': 'Enter remark (optional)',
  'pay.bill.button.submit': 'Submit',
  'pay.bill.payment.button.submit': 'Submit',
  'pay.bill.payment.button.cancel': 'Cancel',
  'pay.bill.payment.type.generic': 'Fee',
};
